import 'scss/solutions/readSolution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
import 'js/libs/utils-tab/index'
import 'js/libs/jquery.slider'
import experienceCtrl from 'js/libs/utils-tts-read-solution'

$(function () {
  experienceCtrl.init()
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/readSolution.js